module.exports = __webpack_public_path__ + "img/03-top-img.60babd85.png";